const finalViewsTypes = {
    SINGLENARROW: 'singlenarrow',
    SINGLEWIDE: 'singlewide',
    TWOCOLS: 'twocols'
};

export {
    finalViewsTypes
};
